















import { Vue, Component } from 'vue-property-decorator';
import CamaraAlerta from '@/pantallas/Camaras/Alerta/CamaraAlerta.vue';

@Component({
  components: { AlertaComponent: CamaraAlerta },
})
export default class CamaraAlertaPantalla extends Vue {}
